// Import React and Hooks
import React from 'react'
// Import Components
import InputForm from '../components/ui/InputForm'
import GroupForm from '../components/ui/GroupForm'



const useFormCustom = () => {


  // Print Input
  function printInput( inputEl:any, register:any, errors:any, additionalClass?:string ):any {


    inputEl = {
      ...inputEl,
      register,
      errors
    }


    return inputEl.type.toLowerCase() === 'group' ?
      <GroupForm
        key={ inputEl.id }
        additionalClass={ additionalClass }
        groupData={ inputEl } /> :
      <InputForm
				key={ inputEl.id }
        additionalClass={ additionalClass }
				inputData={ inputEl } />


  }


  return {
		printInput
	}

}


export default useFormCustom
